import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BackgroundVideoPlayer',
  props: {
    poster: null,
    videoUrl: null,
    videoAutoplay: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    poster?: string,
    videoUrl?: string
    videoAutoplay?: boolean
}



const backgroundVideo = ref(null);

function showVideo() {
    if (!props.videoAutoplay) {
        return;
    }
    const videoElement = backgroundVideo.value as HTMLVideoElement;
    const promise = videoElement.play();
    if (promise !== undefined) {
        promise.then().catch(error => {
            console.log('Play button not supported');
        });
    }
}

return { __sfc: true,props, backgroundVideo, showVideo }
}

})